import "./order-card.scss";

import * as React from "react";

import {cs}              from "@Common/react/chain-services";
import {consumeContext}  from "@Common/react/context";
import {formatDate3}     from "@Common/ui-components/format-date";

import {
    BRANCH_LEVEL, 
    COMPANY_LEVEL}       from "@Xpresso/routes/common/logic/user-level";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEllipsis}      from "@fortawesome/free-solid-svg-icons";

export const OrderCard = ({agentName, branchName, orderName, orderId, orderDate, type, schFulfillment, expShipDate, onOptionsClick: handleOptionsClick, orderDetails}:{
    agentName       : string,
    branchName      : string,
    orderName       : string,
    orderId         : string,
    orderDate       : string,
    type            : string,
    schFulfillment  : string,
    expShipDate     : string,
    onOptionsClick ?: React.MouseEventHandler<HTMLElement>,
    orderDetails    : React.MouseEventHandler<HTMLElement>,
}) => cs(
    consumeContext("userLevels"),
    ({userLevels}) => (
        <article key={orderId} className="order-card-dr4v3n">
            <header>
                <div className="titles">
                    <span className="title"><a onClick={orderDetails}>{orderName}</a></span>
                    <span className="subtitle" 
                        xd-qa-type="label" 
                        xd-qa-name="Order ID"
                    >
                        Order ID {orderId} &#x2022; {orderDate ? formatDate3(new Date((orderDate))) : "N/A"}
                    </span>
                </div>
                <button onClick={handleOptionsClick}><FontAwesomeIcon icon={faEllipsis}/></button>
            </header>
            <ul className="details">
                <li key={type}>
                    <span className="label" xd-qa-type="label" xd-qa-name="Type">Type</span>
                    <span xd-qa-type="text" xd-qa-name="Type">{type}</span>
                </li>
                <li key={schFulfillment}>
                    <span className="label" 
                        xd-qa-type="label" 
                        xd-qa-name="Sch Fulfillment"
                    >
                        Sch Fulfillment
                    </span>
                    <span xd-qa-type="text" 
                        xd-qa-name="Sch Fulfillment"
                    >
                        {schFulfillment ? formatDate3(new Date((schFulfillment))) : "N/A"}
                    </span>
                </li>
                <li key={expShipDate}>
                    <span className="label" xd-qa-type="label" xd-qa-name="Exp Ship Date">Exp Ship Date</span>
                    <span xd-qa-type="text" 
                        xd-qa-name="Exp Ship Date"
                    >
                        {expShipDate ? formatDate3(new Date((expShipDate))) : "N/A"}
                    </span>
                </li>
                {userLevels.userLevel === COMPANY_LEVEL && 
                    <li key={branchName}>
                        <span className="label" xd-qa-type="label" xd-qa-name="Office">Office</span>
                        <span xd-qa-type="text" xd-qa-name={branchName}>{branchName}</span>
                    </li>
                }
                {(userLevels.userLevel === COMPANY_LEVEL || userLevels.userLevel === BRANCH_LEVEL) && 
                    <li key={agentName}>
                        <span className="label" xd-qa-type="label" xd-qa-name="User">User</span>
                        <span xd-qa-type="text" xd-qa-name={agentName}>{agentName}</span>
                    </li>
                }
            </ul>
        </article>
    )
);

